import FilterPrices from './FilterPrices';

export default FilterPrices;
